import { Heading } from "@chakra-ui/react"
import HistoryResetPinCounterMixedHandler from "../../containers/mixedHandlers/cardData/historyResetPinCounter/HistoryResetPinCounterMixedHandler"

const HistoryResetPinCounterPage = () => {
  return (
    <>
      <Heading size="md" mb={'2rem'}>
        Historique Remise à Zéro Compteur Pin
      </Heading>
      <HistoryResetPinCounterMixedHandler />
    </>
  )
}

export default HistoryResetPinCounterPage